module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8017.c849af6a.png";